import React from 'react';
import PropTypes from 'prop-types';
import IssueNew from './IssueNew';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';

const IssueNewPanel = ({changeLocationAction}) => {
  const onFinish = () => changeLocationAction(`/${TYPE_QUALITY_ISSUES}`);
  return <IssueNew onCancel={onFinish} onSuccess={onFinish} showBackLink />;
};

IssueNewPanel.displayName = 'IssueNewPanel';

IssueNewPanel.propTypes = {
  changeLocationAction: PropTypes.func.isRequired
};

export default IssueNewPanel;
